module.exports = __webpack_public_path__ + "img/Telescopios-1.9453b33c.jpg";